import React from "react";
import { useSelector } from "react-redux";
import NumberDisplay from "../../../../components/numberDisplay/numberDisplay";
import PercentChanged from "../../../../components/percentChanged/percentChanged";

const ProfilesCreatedYearToDate = () => {
  const { profilesCreatedYTD, profilesCreatedYTDChange } = useSelector(
    (state) => state.leadsAdded.leads
  );
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <>
      <NumberDisplay value={profilesCreatedYTD} disableAnimation={isUserQa} />;
      <PercentChanged
        changeValue={profilesCreatedYTDChange}
        toolTip="Percentage change from previous year"
        showBorder
      />
    </>
  );
};

export default ProfilesCreatedYearToDate;
